import { injectIntl } from 'react-intl';

import CompartmentFilter from './CompartmentFilter';

export default injectIntl(CompartmentFilter);
